// extracted by mini-css-extract-plugin
export default {"containar":"PCard_containar__YCa2p","Offers":"PCard_Offers__gWQTy","productName":"PCard_productName__dKFaX","para":"PCard_para__MKHaJ","buying_BTNS":"PCard_buying_BTNS__Tf8hL"};